/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable class-methods-use-this */
import {LoggerStrategyType, LoggerUser, LogLevel} from '@src/utility/logger/strategy/type'
import {LOG_TAGS} from '@src/utility/logger/type'
import {otelLogger} from '@src/utility/otel'
import {sentryCaptureMessageFiltered} from '@src/utility/sentry'

export class OtelInjector implements LoggerStrategyType {
  log(name: LOG_TAGS, properties?: Record<string, any>, level: LogLevel = 'info'): void {
    try {
      otelLogger.withMetadata(properties ?? {})[level](name)
    } catch (error) {
      sentryCaptureMessageFiltered(error as Error, 'Error logging Otel log')
    }
  }

  setUser(user: LoggerUser): void {
    try {
      otelLogger.withContext({
        EMAIL: user.email,
        LEAD_ID: user.id
      })
    } catch (error) {
      sentryCaptureMessageFiltered(error as Error, 'Error setting Otel user context')
    }
  }

  resetUser(): void {
    try {
      otelLogger.clearContext(['EMAIL', 'LEAD_ID'])
    } catch (error) {
      sentryCaptureMessageFiltered(error as Error, 'Error resetting Otel user context')
    }
  }
}
